import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'info', // can be 'info', 'success', 'warning', 'error'
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar(state, action) {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
    },
    hideSnackbar(state) {
      state.open = false;
    },
    resetSnackbar(state) {
      state.message = '';
      state.severity = 'info';
    },
  },
});

export const { showSnackbar, hideSnackbar, resetSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
